import axios from 'common/utils/axios';

const activitiesApi = axios('activities');

export const useActivitiesInitiatives = (params: any) => {
  return activitiesApi.get('initiatives', { params });
};
